import { ReactElement } from 'react';
import { assured, chevron_right_blue, superiorAssured } from 'src/assets/QuoteStatus';

const LocofastAssuredTag = ({
  hideText = false,
  className = '',
  showChevron = false,
}: {
  hideText?: boolean;
  className?: string;
  showChevron?: boolean;
}): ReactElement => {
  switch (hideText) {
  case false:
    return (
      <div
        className={`flex bg-primaryGreen2 h-6 rounded-2xl ${className} ${
          showChevron ? '' : 'w-[80px]'
        }`}>
        <img className="p-1" src={assured} />
        <div className="text-xs font-semibold text-primary mt-1">Assured</div>
        {/* Issue */}
        {showChevron && <img className="py-1.5 pl-1 pr-2" src={chevron_right_blue} />}
      </div>
    );
  case true:
    return <img src={superiorAssured} />;
  }
};

export default LocofastAssuredTag;
